/* assets/promo-2x1.js — Countdown para Promo 2x1 */
(function () {
  if (customElements.get('promo-countdown')) return;

  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.deadline;
      if (!raw) return;

      // Acepta "YYYY-MM-DD HH:MM" -> ISO local
      this.deadline = new Date(raw.replace(' ', 'T')).getTime();
      if (isNaN(this.deadline)) return;

      this.label = this.dataset.label || '';
      this.render();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    render() {
      this.innerHTML =
        (this.label
          ? `<span class="promo__countdown-label">${this.label}</span>`
          : '') +
        '<span class="promo__countdown-units">' +
        ['days', 'hours', 'mins', 'secs']
          .map(
            (u) =>
              `<span class="promo__unit"><span class="promo__unit-num" data-unit="${u}">00</span><span class="promo__unit-lbl">${this.unitLabel(
                u
              )}</span></span>`
          )
          .join('') +
        '</span>';
    }

    unitLabel(u) {
      const es = document.documentElement.lang.startsWith('es');
      return {
        days: es ? 'días' : 'days',
        hours: es ? 'hrs' : 'hrs',
        mins: 'min',
        secs: 'seg',
      }[u];
    }

    tick() {
      const diff = this.deadline - Date.now();
      if (diff <= 0) {
        if (this.timer) clearInterval(this.timer);
        this.set('days', 0);
        this.set('hours', 0);
        this.set('mins', 0);
        this.set('secs', 0);
        return;
      }
      const s = Math.floor(diff / 1000);
      this.set('days', Math.floor(s / 86400));
      this.set('hours', Math.floor((s % 86400) / 3600));
      this.set('mins', Math.floor((s % 3600) / 60));
      this.set('secs', s % 60);
    }

    set(unit, val) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (el) el.textContent = String(val).padStart(2, '0');
    }
  }

  customElements.define('promo-countdown', PromoCountdown);
})();
